<template>
  <b-row>
    <b-col md="2">
      <b-form-group
        label="Challan Number"
      >
        <b-form-input
          v-model="challanNumber"
          type="text"
          placeholder="Search Challan Number"
          @input="debouncedFiltersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Challan Date Range"
      >
        <flat-picker
          v-model="challanDateRange"
          placeholder="Select Challan Date Range"
          :config="{ mode: 'range'}"
        />
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group
        label="Supplier"
      >
        <custom-v-select
          v-model="selectedSuppliers"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="supplierOptions"
          label="text"
          placeholder="Select Suppliers"
          multiple
          :close-on-select="false"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group
        label="Retrun Type"
      >
        <custom-v-select
          v-model="selectedReturnTypeOption"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="returnTypeOptions"
          label="text"
          placeholder="Select Return Type"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Status"
      >
        <custom-v-select
          v-model="selectedStatusOption"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="statusOptions"
          label="text"
          placeholder="Select Status"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group label="Created By">
        <custom-v-select
          v-model="selectedUsers"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="usersList"
          placeholder="Select Created By"
          multiple
          :close-on-select="false"
          label="fullname"
          :reduce="(data => data.id)"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Courier"
      >
        <custom-v-select
          v-model="selectedCourier"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="courierOptions"
          label="text"
          placeholder="Select Courier"
          multiple
          :close-on-select="false"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Docket Number"
      >
        <b-form-input
          v-model="docketNumber"
          type="text"
          placeholder="Search Docket Number"
          @input="debouncedFiltersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Dispatch Date Range"
      >
        <flat-picker
          v-model="dispatchDateRange"
          placeholder="Select dispatch Date Range"
          :config="{ mode: 'range'}"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-group
        label="Area"
      >
        <custom-v-select
          v-model="selectedArea"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="areaOptions"
          label="text"
          placeholder="Select Area"
          multiple
          :close-on-select="false"
          :deselect-from-dropdown="true"
          @input="filtersChangeHandler"
        />
      </b-form-group>
    </b-col>
    <b-col md="2">
      <div style="margin-top: 0.7rem">
        <b-form-checkbox
          :checked="checkedFile === true"
          style="margin-bottom: 0.3rem"
          @change="updateCheckedFile(true)"
        >
          Checked File
        </b-form-checkbox>
        <b-form-checkbox
          :checked="checkedFile === false"
          @change="updateCheckedFile(false)"
        >
          Without Checked File
        </b-form-checkbox>
      </div>
    </b-col>
    <b-col md="2">
      <div style="margin-top: 0.7rem">
        <b-form-checkbox
          :checked="actionRequired === true"
          @change="updateActionRequired(true)"
        >
          Action Required
        </b-form-checkbox>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup, BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import { debounce } from 'lodash'
import axios from 'axios'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CustomVSelect,
    FlatPicker,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      challanNumber: null,
      docketNumber: null,
      challanDateRange: null,
      dispatchDateRange: null,
      checkedFile: null,
      actionRequired: null,
      supplierOptions: [],
      areaOptions: [],
      selectedSuppliers: [],
      courierOptions: [],
      selectedCourier: [],
      returnTypeOptions: [
        { text: 'Breakage / Expiry', value: 'Breakage / Expiry' },
        { text: 'Purchase Return', value: 'Purchase Return' },
      ],
      selectedReturnTypeOption: null,
      statusOptions: [
        { text: 'Open', value: 'Open' },
        { text: 'Partially Adjusted', value: 'Partially Adjusted' },
        { text: 'Adjusted', value: 'Adjusted' },
      ],
      selectedStatusOption: null,
      usersList: [],
      selectedUsers: [],
      selectedArea: [],
    }
  },
  watch: {
    challanDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    dispatchDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      axios.get('/supplier_options')
        .then(res => {
          this.supplierOptions = res.data.data
        })
      axios.get('/accounts/areas_options')
        .then(res => {
          this.areaOptions = res.data.data
        })
      axios.get('/delivery/users_list')
        .then(res => {
          this.usersList = res.data
        })

      axios.get('/returns/courier_options')
        .then(res => {
          this.courierOptions = res.data.data
        })
    },
    updateCheckedFile(value) {
      // If clicking the same option, unselect it
      // If clicking different option, select it
      this.checkedFile = this.checkedFile === value ? null : value
      this.filtersChangeHandler()
    },
    updateActionRequired(value) {
      this.actionRequired = this.actionRequired === value ? null : value
      this.filtersChangeHandler()
    },
    debouncedFiltersChangeHandler: debounce(function dummyName() {
      this.filtersChangeHandler()
    }, 500),
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.challanNumber) {
        filtersdata.challan_number = this.challanNumber
      }
      if (this.docketNumber) {
        filtersdata.docket_number = this.docketNumber
      }
      if (this.challanDateRange) {
        const [dateFrom, dateTo] = this.challanDateRange.split(' to ')
        if (dateFrom && dateTo) {
          filtersdata.challan_date_from = dateFrom
          filtersdata.challan_date_to = dateTo
        }
      }
      if (this.dispatchDateRange) {
        const [dateFrom, dateTo] = this.dispatchDateRange.split(' to ')
        if (dateFrom && dateTo) {
          filtersdata.dispatch_date_from = dateFrom
          filtersdata.dispatch_date_to = dateTo
        }
      }
      if (this.selectedSuppliers.length > 0) {
        filtersdata.suppliers = this.selectedSuppliers.map(item => item.id)
      }
      if (this.selectedCourier.length > 0) {
        filtersdata.couriers = this.selectedCourier.map(item => item.id)
      }
      if (this.selectedArea.length > 0) {
        filtersdata.area = this.selectedArea.map(item => item.id)
      }
      if (this.selectedReturnTypeOption) {
        filtersdata.return_type = this.selectedReturnTypeOption.value
      }
      if (this.selectedStatusOption) {
        filtersdata.status = this.selectedStatusOption.value
      }
      if (this.selectedUsers) {
        filtersdata.checked_by = this.selectedUsers
      }
      if (this.checkedFile !== null) {
        if (this.checkedFile === true) {
          filtersdata.checked_pdf_file = 'true'
        } else if (this.checkedFile === false) {
          filtersdata.checked_pdf_file = 'false'
        }
      }
      if (this.actionRequired !== null) {
        filtersdata.action_required = this.actionRequired
      }
      this.$emit('filtersUpdated', filtersdata)
    },
  },

}
</script>
